import { render, staticRenderFns } from "./AdminReportsPresetDialogDelete.vue?vue&type=template&id=58b835dc&scoped=true"
import script from "./AdminReportsPresetDialogDelete.vue?vue&type=script&lang=js"
export * from "./AdminReportsPresetDialogDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminReportsPresetDialogDelete.vue?vue&type=style&index=0&id=58b835dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b835dc",
  null
  
)

export default component.exports